import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withContactDefaultRoute } from './withContactDefaultRoute';
import ChemHeader from '../ChemHeader';
import Confirm from '../Confirm';
import TreeMenu from '../TreeMenu';
import EmailLists from './EmailLists';
import Help from './Help';

class Contact extends ChemComponent {
  	constructor(props) {
		super(props);

		this.state = {
			fullScreen: true,
			menuWidth: 2,
			treeMenuItems: this.filterTreeMenuItems(props.user),
			confirm: ''
		};
	}
		
	componentDidUpdate(prevProps) {
		// if permissions have been populated
		if (!this.objectsAreEqual(prevProps.user, this.props.user)) {
			// update user in state
			this.mergeStateWithArrays({
				treeMenuItems: this.filterTreeMenuItems(this.props.user)
			});
		}
	}
	
	filterTreeMenuItems(user) {
		// copy menu items so we can edit
		var filteredTreeMenuItems = this.copyTreeMenuItems(treeMenuItems);
		
		// if the user is not authorized in any way
		if (!user.contact || user.contact.authLevel < 1) {
			// remove everything
		}
		
		return filteredTreeMenuItems;
	}
	
	setMenuWidth(newWidth) {
		if (newWidth > 12) newWidth = 12;
		else if (newWidth < 1) newWidth = 1;
		
		this.mergeState({
			menuWidth: newWidth,
			renderKey: this.state.renderKey + 1
		});
	}

	removeRoute(menuItems, route) {
		for (var i = 0; i < menuItems.length; i++) {
			if (menuItems[i].nodes) {
				this.removeRoute(menuItems[i].nodes, route);
				if (menuItems[i].nodes.length === 0) {
					menuItems.splice(i--, 1);
				}
			} else {
				if (menuItems[i].route && menuItems[i].route.toUpperCase() === route.toUpperCase()) {
					menuItems.splice(i--, 1);
				}
			}
		}
	}
	
	removeRouteByLabel(menuItems, label) {
		for (var i = 0; i < menuItems.length; i++) {
			if (menuItems[i].nodes) {
				this.removeRouteByLabel(menuItems[i].nodes, label);
				if (menuItems[i].nodes.length === 0) {
					menuItems.splice(i--, 1);
				}
			} else {
				if (menuItems[i].label && menuItems[i].label.toUpperCase() === label.toUpperCase()) {
					menuItems.splice(i--, 1);
				}
			}
		}
	}
	
	showConfirmation(message) {
		var self = this;
		this.mergeState({
			confirm: message
		}, () => self.props.navigate('/Contact/Confirm'));
	}
	
	toggleFullScreen(fullScreen) {
		this.mergeState({ fullScreen: fullScreen });
	}

	render() {
		return (<>
			<ChemHeader parent={this} user={this.props.user} title='Email List Generator' fullScreen={this.state.fullScreen} 
				toggleFullScreen={(fullScreen) => this.toggleFullScreen(fullScreen)}
				showHelp={() => this.props.navigate('/Contact/Help', { helpPath: this.props.location.pathname })} />
			<Container fluid style={{ paddingTop: 20, paddingBottom: 20, backgroundColor: '#e6e6e4', height: 'calc(100vh - 64px)', overflow: 'auto' }}>
				<Row>
					{!this.state.fullScreen && <Col xs={this.state.menuWidth}>
						<TreeMenu parent={this} menuItems={this.state.treeMenuItems} selectedRoute={this.props.location.pathname} />
					</Col>}
					<Col xs={this.state.fullScreen ? 12 : (12 - this.state.menuWidth)}>
					  <main id='main'>
						<Routes>
							<Route path={'/emaillists'} element={<EmailLists parent={this} user={this.props.user} />} />
							<Route path={'/confirm'} element={<Confirm parent={this} user={this.props.user} message={this.state.confirm} />} />
							<Route path={'/help'} element={<Help parent={this} user={this.props.user} />} />
						</Routes>
					  </main>
					</Col>
				</Row>
			</Container>
		</>);
	}
}

// routes defined here so there are no accidents when removing them!
const routes = {
	emailLists: '/Contact/EmailLists'
};

const treeMenuItems = [
	{
		label: 'Email List Generator',
		route: routes.emailLists
	}
];

export default withContactDefaultRoute(Contact);
